export default __webpack_public_path__ + "static/media/pure_cloud.6aec9900.png";